import { FaBolt, FaMobileAlt, FaLock, FaHeadset, FaMoneyBillWave } from "react-icons/fa";

export default function WhyChooseUs() {
  const items = [
    { icon: <FaBolt />, title: "Fast Delivery", desc: "Quick and efficient" },
    { icon: <FaMobileAlt />, title: "Mobile Friendly", desc: "Fully responsive" },
    { icon: <FaLock />, title: "Secure & Reliable", desc: "Safe solutions" },
    { icon: <FaHeadset />, title: "24/7 Support", desc: "Always here to help" },
    { icon: <FaMoneyBillWave />, title: "EMI Available", desc: "Easy payments", highlight: true },
  ];

  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        {/* Simple Header */}
        <h2 className="text-3xl sm:text-4xl font-bold text-center text-gray-900 mb-4">
          Why Choose <span className="text-green-500">Us</span>
        </h2>
        <p className="text-center text-gray-500 mb-12 max-w-2xl mx-auto">
          We deliver excellence through innovation and dedication
        </p>

        {/* Simple Grid */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {items.map((item, i) => (
            <div
              key={i}
              className={`p-5 rounded-xl text-center transition-all duration-300 ${
                item.highlight
                  ? "bg-gradient-to-br from-green-500 to-emerald-600 text-white shadow-lg shadow-green-500/30 scale-105"
                  : "bg-gray-50 hover:bg-gray-100 hover:shadow-md hover:-translate-y-1"
              }`}
            >
              <div className={`text-3xl mb-3 ${item.highlight ? "text-white" : "text-green-500"}`}>
                {item.icon}
              </div>
              <h3 className="text-sm font-semibold mb-1">{item.title}</h3>
              <p className={`text-xs ${item.highlight ? "text-white/80" : "text-gray-500"}`}>
                {item.desc}
              </p>
              {item.highlight && (
                <span className="inline-block mt-2 bg-white/20 text-white text-[8px] px-2 py-0.5 rounded-full">
                  Popular
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}